import script from "./TncSidebar.vue?vue&type=script&lang=js"
export * from "./TncSidebar.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__